<template>
  <div class="nav-bar">
    <van-nav-bar
      left-text="返回"
      fixed
      :title="title"
      left-arrow
      @click-left="onClickLeft"
    >
      <!--通过插槽自定义导航栏右侧的内容 start-->
      <template #right>
        <van-icon name="wap-home-o" size="20" @click="onClickRight" />
      </template>
      <!--通过插槽自定义导航栏右侧的内容 end-->
    </van-nav-bar>
  </div>
</template>
<script>
export default {
  props:{
      title:String
      } ,
  data() {
      return {}
  },
  methods: {
      onClickLeft(){
          this.$router.go(-1)
      },
      onClickRight(){
          this.$router.push('/')
      }
  },
  mounted(){
      console.log(this.title);
  }
};
</script>
<style scoped>
</style>